import React, { useContext } from 'react';
import { 
    Divider, Content, Card, CardTitle, CardBody,
    Level, LevelItem, Tooltip, Button, Spinner, Grid, GridItem
} from '@patternfly/react-core';
import ArrowRightIcon from '@patternfly/react-icons/dist/esm/icons/arrow-right-icon';
import { AuthContext } from 'shared/context/AuthContext';
import { ReactComponent as OvirtLogo } from 'shared/assets/images/svg/ovirt-logo.svg';
import { RedoIcon } from '@patternfly/react-icons';
import VmOverview from "./Vm/VmOverview";
import SummaryVmInfo from "./Vm/SummaryVmInfo";
// import ExtendedVmInfo from "./Vm/test/ExtendedVmInfo";
import NetworkInfo from "./Vm/NetworkInfo";
import DiskInfo from "./Vm/DiskInfo";
import RequiredSoftware from "./RequiredSoftware";


const VmPanel = ({
  ovirtData,
  ovirtLoading,
  refetchOvirt
}) => {
    const context = useContext(AuthContext);
    const userProfile = context.state.userProfile;

    const productName = ovirtData?.product_info?.name || "Brak danych";
    const productVersion = ovirtData?.product_info?.version?.full_version || "-";
    const vmPortalButton = <Button component="a" variant="link" size="sm" icon={<ArrowRightIcon />} iconPosition="start" target="_blank" href="https://rhev.zspw.pl/ovirt-engine/sso/login.html">
      VM Portal
    </Button>

    if (!context.state.isAuthUser || !ovirtData?.vms?.length > 0) return null;

    return (
        <>
        <Card isCompact isFullHeight>
            <CardTitle>
                <Level>
                    <LevelItem>
                        <Tooltip content={productName}>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                <OvirtLogo className="ovirt-logo" style={{ transform: 'translateY(-1px)' }} />
                                <span style={{ marginLeft: '3px', fontSize: 'var(--pf-global--FontSize--sm)' }}>
                                    Open Virtualization
                                </span>
                            </span>
                        </Tooltip>
                    </LevelItem>
                    <LevelItem><small style={{ fontSize: '12px' }}>Name: {productName}</small></LevelItem>
                    <LevelItem><small style={{ fontSize: '12px' }}>Version: {productVersion}</small></LevelItem>
                </Level>
                <Divider />
            </CardTitle>
            <CardBody>
                <Level>
                    <LevelItem><Content component="h4">Twoje maszyny wirtualne {vmPortalButton}</Content></LevelItem>
                    {ovirtLoading && (
                        <LevelItem>
                            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <Spinner size="sm" />
                                <small>Ładowanie...</small>
                            </span>
                        </LevelItem>
                    )}
                    <LevelItem>
                        <Button 
                            variant="plain" 
                            icon={<RedoIcon />} 
                            onClick={refetchOvirt} 
                            isDisabled={ovirtLoading} 
                        />
                    </LevelItem>
                </Level>
                {!ovirtLoading && ovirtData && (
                    <>
                    {ovirtData.vms.map((vm) => (
                        <React.Fragment key={vm.id}>
                        <Grid
                            hasGutter
                            span={12}
                            style={{
                                fontSize: "13px",
                                lineHeight: "1.6"
                            }}
                        >
                            <GridItem span={6}>
                                <VmOverview
                                    vm={vm}
                                    ovirtLoading={ovirtLoading}
                                />
                            </GridItem>
                            <GridItem span={6}>
                                <SummaryVmInfo
                                    vm={vm}
                                    ovirtLoading={ovirtLoading}
                                />
                            </GridItem>
                            <GridItem span={6}>
                                <NetworkInfo
                                    vm={vm}
                                />
                            </GridItem>
                            <GridItem span={6}>
                                <DiskInfo
                                    vm={vm}
                                />
                            </GridItem>
                        </Grid>
                        <br />
                        {/* <ExtendedVmInfo
                            vm={vm}
                            userProfile={userProfile}
                            ovirtLoading={ovirtLoading}
                        /> */}
                        <Divider />
                        <br />
                        </React.Fragment>
                    ))}
                    </>
                )}
                {!ovirtLoading && (
                    <RequiredSoftware
                        userProfile={userProfile}
                    />
                )}
            </CardBody>
        </Card>
        </>
    );
};

export default VmPanel;